function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmotionSadFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.008 16.006c0-7.715 6.276-13.992 13.991-13.992S29.991 8.291 29.99 16.006c0 7.715-6.276 13.991-13.99 13.991-7.716 0-13.992-6.275-13.992-13.99zm1.974 0c0 6.627 5.39 12.018 12.017 12.018 6.626 0 12.017-5.392 12.017-12.018S22.626 3.99 16 3.99c-6.626 0-12.017 5.391-12.017 12.017z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.132c-2.999 0-5.67 1.404-6.426 2.704a.794.794 0 001.373.797c.399-.686 2.428-1.913 5.052-1.913 2.575 0 4.504 1.23 5.115 2.006a.794.794 0 001.248-.983c-.992-1.257-3.405-2.61-6.363-2.61zM23.154 15.428c-.127.203-1.528 2.163-1.528 3.022 0 .972.685 1.763 1.528 1.763.842 0 1.528-.791 1.528-1.763 0-.86-1.4-2.819-1.528-3.021zM10.704 14.764a1.86 1.86 0 001.859-1.858 1.86 1.86 0 00-1.859-1.859 1.86 1.86 0 00-1.858 1.859 1.86 1.86 0 001.858 1.858zM21.296 14.764a1.86 1.86 0 001.858-1.858 1.86 1.86 0 00-1.858-1.859 1.86 1.86 0 00-1.859 1.859 1.86 1.86 0 001.858 1.858z",
    fill: props.color
  }));
}

export default SvgIconEmotionSadFilled;